import type { VoipRoomStore } from './interfaces'

import { Voip, WebVoip } from '@brighterly/lib-core-types/support/enums'

export const getters = {
  getRoomData: (state: VoipRoomStore): VoipRoomStore['roomData'] => state.roomData,
  isRoomLoading: (state: VoipRoomStore): VoipRoomStore['roomLoading'] => state.roomLoading,
  isLiveKitRoom: (state: VoipRoomStore): boolean => state.roomData?.provider === WebVoip.LiveKit,
  getBookingVoip: (state: VoipRoomStore): VoipRoomStore['bookingVoip'] => state.bookingVoip,
  isAlternativeVoip: (state: VoipRoomStore): boolean => state.bookingVoip !== null && state.bookingVoip !== Voip.Web,
}
